export class PolicyData {
    public get MinimumLength(): number {
        return this.minimumLength
    }

    public get RequireUppercase(): boolean {
        return this.requireUppercase
    }

    public get RequireLowercase(): boolean {
        return this.requireLowercase
    }

    public get RequireNumbers(): boolean {
        return this.requireNumbers
    }

    public get RequireSymbols(): boolean {
        return this.requireSymbols
    }

    constructor(
        private minimumLength: number,
        private requireUppercase: boolean,
        private requireLowercase: boolean,
        private requireNumbers: boolean,
        private requireSymbols: boolean,
    ) { }
}